
import React, { useEffect, useRef } from 'react';
import MediaViewer from 'components/common/MediaViewer';
import { OBJ } from 'constants';

const TalkingAssistantAnimation = ({ isReading, width, height, avatar }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleVideoPlay = async () => {
            try {
                await video.play();
            } catch (error) {
                console.error("Error attempting to play the video:", error.message);
            }
        };

        if (isReading) {
            handleVideoPlay();
        }

        const handleVideoEnd = () => {
            if (isReading) handleVideoPlay();
        };

        video.addEventListener('ended', handleVideoEnd);
        return () => video.removeEventListener('ended', handleVideoEnd);
    }, [isReading, avatar]);

    return <MediaViewer type={OBJ.AVATARS} uploadId={avatar.upload_id} videoRef={videoRef} width={width} height={height}/>
};

export default TalkingAssistantAnimation;
